import styled from 'styled-components'

import { breakpoints } from '@/config/layout'

const PageContainer = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  flex-grow: 1;
`

const MobileGrid = styled.div<{ showNavigation: boolean }>`
  display: grid;
  grid-template-columns: 1fr;
  position: absolute;
  inset: 0;

  ${({ showNavigation }) =>
    showNavigation
      ? `
      grid-template-rows: var(--safe-area-inset-top) auto auto 1fr;
      grid-template-areas:
        'safe-top'
        'banner'
        'header'
        'content'
        'navigation';`
      : `
      grid-template-rows: var(--safe-area-inset-top) auto auto 1fr;
      grid-template-areas:
        'safe-top'
        'banner'
        'header'
        'content';`}

  width: 100%;
  overflow: hidden;
`

const DesktopGrid = styled.div<{ showNavigation: boolean }>`
  display: grid;
  position: absolute;
  inset: 0;
  width: 100%;
  overflow: hidden;

  /* Default to Tablet layout (min-width: 843px in original) */
  ${({ showNavigation }) =>
    showNavigation
      ? `
      grid-template-columns: 1fr 4fr;
      grid-template-areas:
        'navigation safe-top'
        'navigation banner'
        'navigation header'
        'navigation content';
      `
      : `
      grid-template-columns: 1fr;
      grid-template-areas:
        'safe-top'
        'banner'
        'header'
        'content';
      `}
  grid-template-rows: var(--safe-area-inset-top) auto auto 1fr;

  @media ${breakpoints.l} {
    ${({ showNavigation }) =>
      showNavigation
        ? `
        grid-template-columns: 1fr 5fr;
        grid-template-areas:
          'navigation safe-top'
          'navigation banner'
          'navigation header'
          'navigation content';
        `
        : `
        grid-template-columns: 1fr;
        grid-template-areas:
          'safe-top'
          'banner'
          'header'
          'content';
        `}
  }
`

const PageContent = styled.div`
  grid-area: content;
  overflow: hidden;
`

const PageDetail = styled.div`
  grid-area: content-detail;
`

const SafeAreaTop = styled.div<{ $bgColor?: string }>`
  grid-area: safe-top;
  background-color: ${({ $bgColor }) => $bgColor ?? 'transparent'};
`

export { DesktopGrid, MobileGrid, PageContainer, PageContent, PageDetail, SafeAreaTop }
